import { produce } from 'immer'
import {
  GET_VIRTUAL_CARD_SUCCESS,
  GET_VIRTUAL_CARDS_FAILURE,
  GET_VIRTUAL_CARDS_INIT,
  GET_VIRTUAL_CARDS_SUCCESS,
  GetVirtualCardActions,
  GetVirtualCardsActions,
} from 'src/redux/actions/data/virtualCards.actions'

export interface VirtualCardsSnapshotPaginatedDataState {
  ids: string[]
  loading: boolean
  complete: boolean
  totalItems?: number
}

export const initialState: VirtualCardsSnapshotPaginatedDataState = {
  ids: [],
  loading: false,
  complete: false,
}

export type Actions = GetVirtualCardsActions | GetVirtualCardActions

const VirtualCardsSnapshotPaginatedDataReducer = (
  state = initialState,
  action: Actions,
): VirtualCardsSnapshotPaginatedDataState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_VIRTUAL_CARDS_INIT: {
        draft.loading = true
        return draft
      }

      case GET_VIRTUAL_CARDS_SUCCESS: {
        draft.loading = false
        draft.ids =
          action.payload.pagination.page === 0
            ? action.payload.virtualCards.map((virtualCard) => virtualCard.id)
            : [
                ...draft.ids,
                ...action.payload.virtualCards.map(
                  (virtualCard) => virtualCard.id,
                ),
              ]
        draft.complete = true
        draft.totalItems = action.payload.pagination.totalItems
        return draft
      }

      case GET_VIRTUAL_CARDS_FAILURE: {
        draft.loading = false
        draft.complete = true
        return draft
      }

      case GET_VIRTUAL_CARD_SUCCESS: {
        draft.ids = draft.ids.includes(action.payload.virtualCard.id)
          ? draft.ids
          : [action.payload.virtualCard.id, ...draft.ids]
        return draft
      }
    }
  })
}

export default VirtualCardsSnapshotPaginatedDataReducer
